/* eslint-disable no-console */
export class ReconnectingEventSource {
  private eventSource?: EventSource;
  private numberOfConnectionFailures = 0;
  private readonly maxReconnectPauseTimeSeconds = 60;
  private isReconnecting = false;
  private closedByCaller = false;

  constructor(
    private readonly url: string,
    private readonly callbacks: {
      onMessage: (data: unknown) => void;
      //TODO: a callback to tell we're trying to reconnect?
      //Maybe also a max tries?
    }
  ) {
    this.connect();
  }

  close() {
    this.eventSource?.close();
    this.eventSource = undefined;
    this.closedByCaller = true;
  }

  private connect(): void {
    //console.info(`connecting to SSE`);
    this.eventSource = new EventSource(this.url);
    this.eventSource.onmessage = async (ev: MessageEvent<unknown>) => {
      this.callbacks.onMessage(ev.data);
    };

    this.eventSource.onerror = (error: Event) => {
      //console.warn(`SSE error: ${error} -- state ${this.eventSource?.readyState}`);
      const connectionIsClosed = this.eventSource?.readyState === EventSource.CLOSED;
      if (connectionIsClosed) {
        //console.info('closed event source');
        this.eventSource?.close();
        this.eventSource = undefined;
        this.reconnectAfterPause();
      }
    };

    this.eventSource.onopen = () => {
      //console.info(`connected`);
      this.numberOfConnectionFailures = 0;
    };
  }

  private reconnectAfterPause(): void {
    if (!this.isReconnecting) {
      this.isReconnecting = true;
      try {
        // Try to reconnect after a wait.
        this.numberOfConnectionFailures += 1;
        const pauseTimeBeforeReconnection = this.getPauseTimeBeforeReconnectionInMs();

        //console.info(`will try to reconnect to SSE after ${pauseTimeBeforeReconnection / 1000}s`);
        setTimeout(() => {
          if (!this.closedByCaller) {
            this.isReconnecting = false;
            //console.info("reconnect from reconnect");
            this.connect();
          }
        }, pauseTimeBeforeReconnection);
      } catch (error) {
        console.error(error);
      }
    }
  }

  private getPauseTimeBeforeReconnectionInMs() {
    return Math.min(
      this.maxReconnectPauseTimeSeconds * 1000,
      // try to reconnect after 200 ms, then with increasing pause
      1 + 200 * 1.4 ** (this.numberOfConnectionFailures - 1)
    );
  }
}
